import Text, { TEXT_TAG, TEXT_VARIANT } from '@pixum/text';
import type { CartAddressData } from 'services/types';
import { translateCountry, type CountryIso, type LocaleIso } from 'utils';

export interface AddressLinesProps {
  address: CartAddressData;
  locale: LocaleIso;
}

/** Renders the postal lines of an address as stacked text spans, for use inside a SummaryCard. */
export function AddressLines({ address, locale }: AddressLinesProps) {
  return (
    <>
      {address.company && (
        <Text variant={TEXT_VARIANT.BODY} tag={TEXT_TAG.SPAN}>
          {address.company}
        </Text>
      )}
      <Text variant={TEXT_VARIANT.BODY} tag={TEXT_TAG.SPAN}>
        {address.firstName} {address.lastName}
      </Text>
      <Text variant={TEXT_VARIANT.BODY} tag={TEXT_TAG.SPAN}>
        {address.street}
      </Text>
      {address.streetAddOn && (
        <Text variant={TEXT_VARIANT.BODY} tag={TEXT_TAG.SPAN}>
          {address.streetAddOn}
        </Text>
      )}
      <Text variant={TEXT_VARIANT.BODY} tag={TEXT_TAG.SPAN}>
        {address.zip} {address.city}
      </Text>
      {address.country && (
        <Text variant={TEXT_VARIANT.BODY} tag={TEXT_TAG.SPAN}>
          {translateCountry(locale, address.country.toUpperCase() as CountryIso)}
        </Text>
      )}
    </>
  );
}
